import type { ISiteTagsDto } from "app/pages/sales-intelligence/domain/leads/types/filter-values";
import { type InclusionOption, inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

export class SiteTagsFilterValue {
    public readonly inclusion: InclusionOption;
    public readonly values: readonly string[];

    static readonly defaultInclusion: InclusionOption = inclusionOptionMap.includeOnly;

    constructor(value?: ISiteTagsDto) {
        const dto = SiteTagsFilterValue.toDtoValue(value);

        this.inclusion = dto.inclusion;
        this.values = dto.values;
    }

    static createDefault(): SiteTagsFilterValue {
        return new SiteTagsFilterValue();
    }

    static toDtoValue(value: Partial<ISiteTagsDto> = {}): ISiteTagsDto {
        const { values = [], inclusion = SiteTagsFilterValue.defaultInclusion } = value;

        return { inclusion, values };
    }

    isEmpty(): boolean {
        return this.values.length === 0;
    }

    with(partial: Partial<ISiteTagsDto>): ISiteTagsDto | undefined {
        const next: ISiteTagsDto = {
            inclusion: this.inclusion,
            values: this.values,
            ...partial,
        };

        return next.values.length === 0 ? undefined : next;
    }
}
